import { createStore } from 'vuex'

const state = {
  menu_data: [],
  isLoadRoute: false,
  editableTabsValue: '1',
  editableTabs: [
    {
        title: '首页',
        name: '首页',
        content: '首页'
    }
  ]
}

const mutations = {
  setMenuData(state, data) {
    state.menu_data = data
  },
  setIsLoadRoute(state, data) {
    state.isLoadRoute = data
  },
  addEditableTabs(state, tab) {
    let idx = state.editableTabs.findIndex((item) => item.name === tab.name)
    if (idx === -1) {
      state.editableTabs.push({
        title: tab.name,
        name: tab.name,
      })
    }
    state.editableTabsValue = tab.name
  }
}

export default createStore({
  state,
  getters: {
  },
  mutations,
  actions: {
  },
  modules: {
  }
})
